<template>
  <b-row>
    <b-col cols="12" lg="6">
      <b-card no-header>
        <template slot="header">
          User id:  {{ $route.params.id }}
        </template>
        <b-table striped small fixed responsive="sm" :items="getUser(userObj)" :fields="fields">
          <template slot="value" slot-scope="data">
            <strong>{{data.item.value}}</strong>
          </template>
        </b-table>
        <template slot="footer">
          <b-button @click="goBack">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { db } from '@/config/devowqlo';
export default {
  name: 'User',
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  userId: '',
  data: () => {
    return {
      role: '',
      userId: '',
      fields: [
        {key: 'key'},
        {key: 'value'},
      ],
    }
  },
  created() {
    //this.$route('members', db.ref('teams/' + this.$route.params.id + '/members/'))
    console.log(this.$route.params.info)
    const infoString = String(this.$route.params.info)
    const infoSplit = infoString.split('&&')
    console.log(infoSplit)
    this.userId = infoSplit[0]
    var rolePath = ''
    if(infoSplit[1] == "coach"){
      rolePath = infoSplit[1] + "es/"
    }else{
       rolePath = infoSplit[1] + "s/"
    }
    this.$bindAsObject('userObj', db.ref('users/' + rolePath))
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    getUser(userObj){
      // console.log(this.$route.params.info)
      // const infoString = String(this.$route.params.info)
      // const infoSplit = infoString.split('&&')
      // console.log(infoSplit)
      // if(infoSplit[1] == "coach"){
      //   const userDetails = Object.entries(coachObj.child('coaches')[infoSplit[0]])
      //   console.log(userDetails)
      //   //return teamDetails.map(([key, value]) => {return {key: key, value: value}})
      //   return userDetails.map(([key, value]) => {
      //     if(key == "created"){
      //       value = new Date(value).toGMTString()
      //     }
      //     return {key: key, value: value}
      //   })
      // }
      const userDetails = Object.entries(userObj[this.userId])
      //const userValues = Object.values(userObj[this.userId]).slice(0, Object.values(userObj[this.userId]).length-1)
      console.log(userDetails)
      //console.log(userValues)
      //return teamDetails.map(([key, value]) => {return {key: key, value: value}})
      return userDetails.map(([key, value]) => {
        if(key == "created"){
          value = new Date(value).toGMTString()
        }
        if(key == "modified"){
          value = new Date(value).toGMTString()
        }
        return {key: key, value: value}
      })

    },
  }
}
</script>
